import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { trackEvent as track } from '../utils/analytics';
import { StoryProblem } from '../components/story/StoryProblem';
import { StoryLearning } from '../components/story/StoryLearning';
import { StoryToday } from '../components/story/StoryToday';
export function About() {
  useEffect(() => {
    track('Page Viewed', {
      page: 'About'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-7765" data-mp="326gf8ehygxvh">
      <Header data-id="element-7766" data-mp="376ce5zbspz46" />
      <main className="pt-[120px]" data-id="element-7767" data-mp="376vqn0iofvat">
        <StoryProblem data-id="element-7768" data-mp="2sa4x37vopdt4" />
        <StoryLearning data-id="element-7769" data-mp="2samuw8xzw035" />
        <StoryToday data-id="element-7770" data-mp="2s9bp63kzoi9e" />
      </main>
      <Footer data-id="element-7771" data-mp="2schdvhpphi4l" />
    </div>;
}